<script>
import { VExpansionPanelContent } from 'vuetify/lib';
export default VExpansionPanelContent;
</script>
